import { Box, TableCell } from '@mui/material'
import React from 'react'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'
import { formatCurrency } from '../../../../pages/DataEntryPage/utils/currency'
import { useProcessContext } from '../../../../store'
import { getKeyOfValue } from '../../../../pages/DataEntryPage/utils/utils'
import { CURRENCY_COUNTRY_CODE } from '../../../../utility/constants'

const TableCellCurrency = ({ isHidden, color, value, previewCurrency, field, width, defaultCurrency }) => {
  const companyDetails = useProcessContext((state) => state.processContext.companyDetails)
  const currencySubfield = field?.id ? String(field.id).split('__')[0] : ''

  const { previewText } = useResponsiveTypography()

  const currencySymbol = previewCurrency && previewCurrency[currencySubfield]
  const currencyCode = currencySymbol ? getKeyOfValue(CURRENCY_COUNTRY_CODE, currencySymbol) : undefined

  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      <Box sx={{ overflow: 'auto' }}>
        {formatCurrency(value, currencyCode, {
          defaultCurrency: defaultCurrency || companyDetails?.default_currency_code,
        })}
      </Box>
    </TableCell>
  )
}

export default TableCellCurrency
